import { render, staticRenderFns } from "./TrainingWidget.vue?vue&type=template&id=ee01ea18&"
import script from "./TrainingWidget.vue?vue&type=script&lang=js&"
export * from "./TrainingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainingWidget.vue"
export default component.exports